import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-last-bid-dialog',
	templateUrl: './last-bid-dialog.component.html',
	styleUrls: ['./last-bid-dialog.component.scss'],
})
export class LastBidDialogComponent implements OnInit {
	lastBidDetails: UntypedFormGroup;

	constructor(
		public dialogRef: MatDialogRef<LastBidDialogComponent>,
		private formBuilder: UntypedFormBuilder
	) {}

	ngOnInit() {
		this.lastBidDetails = this.formBuilder.group({
			lastBid: ['', Validators.required],
		});
	}

	submitLastBid() {
		let payload = Object.assign({}, this.lastBidDetails.value);
		payload.lastBid = Number(payload.lastBid) * 100;
		this.closeDialog(payload);
	}

	closeDialog(data: { lastBid: number } | null): void {
		this.dialogRef.close(data);
	}
}
